module.exports = __webpack_public_path__ + "img/deepwater-green-inner-corner.ea74baa4.png";